// src/routes/suppliersRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Suppliers from '../pages/suppliers/Suppliers';
import CreateSupplier from '../pages/suppliers/CreateSupplier';
import EditSupplier from '../pages/suppliers/EditSupplier';
import ProtectedRoute from '../components/global/ProtectedRoute';

const suppliersRoutes = (
    <>
        {/* Suppliers List */}
        <Route
            path="/suppliers"
            element={
                <ProtectedRoute requiredPermission="suppliers_list">
                    <Suppliers />
                </ProtectedRoute>
            }
        />

        {/* Suppliers Archive */}
        <Route
            path="/suppliers/archive"
            element={
                <ProtectedRoute requiredPermission="suppliers_archive_list">
                    <Suppliers />
                </ProtectedRoute>
            }
        />

        {/* Create Supplier */}
        <Route
            path="/suppliers/create"
            element={
                <ProtectedRoute requiredPermission="suppliers_create">
                    <CreateSupplier />
                </ProtectedRoute>
            }
        />

        {/* Edit Supplier */}
        <Route
            path="/suppliers/:id/edit"
            element={
                <ProtectedRoute requiredPermission="suppliers_edit">
                    <EditSupplier />
                </ProtectedRoute>
            }
        />
    </>
);

export default suppliersRoutes;
